<app-toast-container></app-toast-container>
<div class="app-bg-overlay"></div>

<div class="flex min-h-screen bg-gray-50/50 overflow-hidden relative">
    <!-- Sidebar (Only shown if logged in) -->
    @if (isLoggedIn) {
    <app-sidebar [(isOpen)]="isSidebarOpen" [isMobile]="isMobile" (onOpenSettings)="showSettings = true"
        (onOpenUser)="showUserModal = true" (onOpenAssets)="showAssets = true"></app-sidebar>
    }

    <main class="flex-1 overflow-y-auto transition-all duration-300 relative" [class.lg:pl-20]="isLoggedIn">
        <router-outlet />
    </main>

    <!-- Modals -->
    @if (showSettings) {
    <app-project-settings (onClose)="showSettings = false"></app-project-settings>
    }
    @if (showUserModal) {
    <app-user-profile-modal (onClose)="showUserModal = false" (onLogoutRequested)="onLogout()"></app-user-profile-modal>
    }
    @if (showAssets) {
    <app-asset-manager (onClose)="showAssets = false"></app-asset-manager>
    }
</div>